<template>
  <b-modal :visible="visible"
           :title="modalTitle"
           :hide-header-close="submitting"
           :header-close-label="$t('general.close')"
           :no-close-on-backdrop="submitting"
           :no-close-on-esc="submitting"
           centered
           hide-footer
           @hide="onHide"
           @shown="focusInput"
  >
    <form class="development-plan-form" novalidate @submit.prevent="submit">
      <label :for="inputId">{{ $t('general.development_plan') }}</label>
      <textarea :id="inputId"
                ref="planInput"
                v-model="text"
                :aria-describedby="displayError ? `${inputId}-error` : null"
                :aria-invalid="displayError ? 'true' : 'false'"
                :disabled="submitting"
                :placeholder="$t('general.development_plan_placeholder')"
                class="form-control"
                rows="6"
                @input="localError = ''"
      ></textarea>
      <p v-if="displayError" :id="`${inputId}-error`" class="development-plan-form__error" role="alert">
        {{ displayError }}
      </p>
      <div class="development-plan-form__actions">
        <button :disabled="submitting" class="btn btn-outline-secondary" type="button" @click="$emit('close')">
          {{ $t('general.cancel') }}
        </button>
        <button :disabled="submitting || !text.trim()" class="btn btn-default" type="submit">
          <span v-if="submitting" aria-hidden="true" class="spinner-border spinner-border-sm mr-1"></span>
          {{ submitting ? $t('general.saving') : $t('general.save') }}
        </button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import { BModal } from "bootstrap-vue";

export default {
  name: "DevelopmentPlanModal",
  components: { BModal },
  props: {
    visible: { type: Boolean, default: false },
    editing: { type: Boolean, default: false },
    initialText: { type: String, default: "" },
    submitting: { type: Boolean, default: false },
    error: { type: String, default: "" },
  },
  data() {
    return { text: "", localError: "" };
  },
  computed: {
    inputId() {
      return `development-plan-${this._uid}`;
    },
    modalTitle() {
      return this.$t(this.editing ? "general.edit_development_plan" : "general.add_development_plan");
    },
    displayError() {
      return this.localError || this.error;
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler(isVisible) {
        if (isVisible) {
          this.text = this.initialText;
          this.localError = "";
        }
      },
    },
  },
  methods: {
    focusInput() {
      this.$refs.planInput?.focus();
    },
    onHide(event) {
      if (this.submitting && this.visible) {
        event.preventDefault();
        return;
      }
      this.$emit("close");
    },
    submit() {
      if (this.submitting) return;
      const text = this.text.trim();
      if (!text) {
        this.localError = this.$t("general.development_plan_required");
        return;
      }
      this.localError = "";
      this.$emit("submit", text);
    },
  },
};
</script>

<style scoped>
.development-plan-form label {
  display: block;
  margin-bottom: 8px;
  font-weight: 600;
}

.development-plan-form textarea {
  min-height: 150px;
  resize: vertical;
}

.development-plan-form__error {
  margin: 10px 0 0;
  color: #c53030;
  font-size: 13px;
}

.development-plan-form__actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 18px;
}
</style>
